module.exports = __webpack_public_path__ + "img/soccer_m.21dfe28e.svg";